module.exports = __webpack_public_path__ + "static/media/pattern-9.f95c497e.svg";